module.exports = {
  pleaseWait: 'Please wait',
  loading: 'loading',
  Billing: 'Billing',
  billingTips: 'Your Purchased History',
  ID: 'ID',
  FAQ: 'FAQ',
  TC: 'T&C',
  Copyright: '© 2026 All Rights Reserved.',
  GenerateImage: 'Generate Image',
  generateTips1: 'Our AI image generator brings imagination to life, producing stunning art, illustrations, and photos in seconds. Unleash creativity and express yourself in new ways with the power of AI. Explore endless possibilities, from crafting unique marketing materials to creating beautiful artwork, all with supreme ease and efficiency.',
  generateTips2: 'Enter a few words below, and watch Snapai transform text into incredible art.',
  Prompt: 'Prompt',
  PromptTips1: 'Tell AI what to draw.',
  PromptTips2: 'Tips: describe mood and lighting. See page tips for more.',
  PromptTips3: 'Note: AI may not follow instructions and cannot count.',
  Generate: 'Generate',
  ChancesLeft: 'Chances Left',
  BuyChances: 'Buy More Chances',
  generateImageTips1: 'Input what you want',
  generatePromptsTips1: 'Input what you don\'t want',
  indexTips1: 'Daily Free Chance <br /> Available!',
  indexTips2: 'Choose one of these',
  ImageRestorer: 'Image Restorer',
  Continue: 'Continue',
  language0: 'Language',
  language: 'Choose Language',
  languageTips: 'Choose your language here',
  Submit: 'Submit',
  change: 'Change',
  English: 'English',
  Myanmar: 'Myanmar',
  Cambodia: 'Khmer',
  Login: 'Login',
  Logout: 'Log out',
  getCode: 'Resend',
  loginTips: 'Enter a phone number',
  profile: 'Profile',
  phoneNumber: 'Phone Number',
  SubscribedSince: 'Subscribed since',
  RemainingChances: 'Remaining chances',
  cgtips2: 'Only 149ks/daily,<br />please click OK to subscribe.',
  cgtips2W: 'Only 599ks/weekly,<br />please click OK to subscribe.',
  cgtips2M: 'Only 1999ks/monthly,<br />please click OK to subscribe.',
  OK: 'OK',
  PictureRestorer: 'Picture Restorer',
  PictureTips1: 'Restore, sharpen, and repair pictures with AI. Snapai builds on the latest research to automatically remove scratches, sharpen colors, and enhance faces, transforming damaged photos into cherished memories. Our free service repairs both color photos and black & white ones.',
  Upload: 'Upload',
  PictureTips2: 'Has Scratch?',
  Restore: 'Restore',
  uploadTips: 'Please upload pictures',
  PurchaseChances: 'Purchase Chances',
  History: 'History',
  purchaseTips1: 'Your total chances',
  purchaseTips2: 'One Time Purchase',
  Daily: 'Daily',
  Weekly: 'Weekly',
  OneTime: 'One Time',
  Purchase: 'Purchase',
  DailyKyats: '149 Kyats',
  WeeklyKyats: '599 Kyats',
  OneTimeChance: '149 Ks/Chance',
  Subscribe: 'Subscribe',
  purchaseTips3: 'Please choose how many <strong>CHANCES</strong> to buy.',
  BuyNow: 'Buy Now',
  logout: 'Logout',
  petTitle1: 'AI Pets Anime',
  petTitle2: 'Choose Style',
  petContent1: ' transforms your beloved pet’s photo into a whimsical, anime-style masterpiece. Perfect for pet lovers and anime enthusiasts, Snapai offers a fun and personalized way to celebrate your furry friends.',
  sexTitle1: 'AI Personal Anime',
  sexTitle2: 'Choose Gender',
  sexContent1: 'Brings your imagination to life by generating anime-style photos based on written prompts. Whether you\'re a fan of anime, a storyteller, or a designer, AI Anime Photo empowers you to create vibrant, high-quality anime-style visuals effortlessly, blending advanced AI with your unique vision.',
  sexContent2: 'Choose the gender below and enter the prompt below. Watch Snapai transfor text into incredible art.',
  Female: 'Female',
  Male: 'Male',
  Style1: 'Style 1',
  Style2: 'Style 2',
  Style3: 'Style 3',
  Comic: 'Comic',
  Disney: 'Disney',
  Ghibli: 'Ghibli',
  Animalanime: 'Selfie Anime',
  HumanAnime: 'Human Anime',
  Guidance: 'Guidance',
  PetAnime: 'Pet Anime',
  landTips1: 'Generate Stunning Photos &',
  landTips2: 'WIN BIG PRIZES!',
  landTips3: 'Transform your imagination into reality with SnapAI! From stunning photo generation to artistic masterpieces, SnapAI empowers you to create visuals like never before. Dive into a world of limitless possibilities.',
  show401tip: 'Balance not enough',
  show400dailytip: 'Time out, please send "ON1" to 548 to win the big prize.',
  show400weeklytip: 'Time out, please send "ON7" to 548 to win the big prize.',
  register: 'Register',
  invitation: 'Invitation',
  invitationTips: 'Copy and send invite using the link below',
  InviteNow: 'Invite Now',
  copySuccess: 'Copy Success!',
  process: 'Generating',
  downTips1: 'Please copy the link into browser and download.',
  downloadImage: 'Download image',
  downloadImageTips: 'Tap Download to save the image.',
  copyLink: 'Copy link',
  free: 'Free',
  aiAnimeTitle: 'AI Couples Anime',
  aiAnimeCt1: 'Transform your original couple photos into anime-style images, making your romantic memories even more fun. Whether you\'re an anime enthusiast or a designer, AI Anime Photo allows you to effortlessly create meaningful and high-quality anime-style visuals, perfectly blending advanced AI technology with your romantic moments. ',
  aiAnimeCt2: 'Select the style below and upload your original photo to watch Snapai transform your sweet memories into stunning artworks.',
  comingsoonT: 'coming soon',
  SubscribePackage: 'Subscribe Package',
  landfont1: 'Turn photo into stunning anime artwork.',
  landfont2: 'Transform your couple photos into beautiful anime characters.',
  landfont3: 'Write a prompt to generate beautiful images',
  landfont4: 'Turn your pets into adorable anime characters with AI magic!',
  landfont5: 'Rediscover your memories with AI-powered photo restoration.',
  SmartCutout: 'Smart Cutout',
  letgo: 'Let’s Go',
  IpIMage: 'ID Photo',
  IpIMageTip: 'Need a license or ID photo created? We’ve got you covered!',
  IpIMage_content: 'The original image uploaded for the ID photo must ensure that the face of the person is clear, without any obstruction, and the shoulders are level and even. Otherwise, the generation may fail. ',
  snapbot: 'SnapBot',
  snapbot_hi: 'Hi, I’m SnapBot.',
  help_today: 'How can I help you today?',
  think_ip: '🤖 Thinking...',
  Coloring_old_photos: 'Image Recolor',
  Coloring_old_photos_tips: 'Bring your memories back to life by restoring color\n' +
    'to your vintage photos. Our AI-powered tool\n' +
    'automatically analyzes and adds natural color tones,\n' +
    'preserving the charm of the original while\n' +
    'enhancing its visual appeal.\n',
  Coloring_old_photos_tips2: ' Bring your old photos to life with AI-powered color restoration.',
  BgFusion: 'Smart Blend',
  BgFusion_tips2: 'Customize your photo with a background of your choice',
  BgFusion_tips: 'Customize your photo with a background of your choice.\n' +
    'Our smart AI replaces the original backdrop\n' +
    'and blends your image naturally into the new scene ',
  Upload_bg: 'Upload Background',
  Upload_pt: 'Upload Portrait',
  Recolor: 'Recolor',
  snapbotTips1: 'Fast Search Results',
  snapbotTips2: 'Natural Language processing',
  snapbotTips3: 'Big Data Analysis',
  snapbotTips4: 'AI-powered Algorithms',
  snapbotInput1: 'Tap here to start with SnapBot',
  white: 'white',
  blue: 'blue',
  '1 inch': '1 inch',
  '2 inches': '2 inch',
  '3 inches': '3 inch',
  landTips11: 'Create Awesome Photos &',
  ChangeHairstyle: 'Hairstyle Magic',
  ChangeHairstyle_short: 'Create and try out your Imagined Hairstyles',
  ChangeHairstyle_content_1: 'The snapai app offers a feature for changing hairstyles, allowing users to try on different haircuts in real-time or via uploaded photos. This feature leverages AI technology to analyze the user’s facial features and suggest hairstyles that suit their face shape, preferences, and style. Users can experiment with various looks, ranging from subtle changes to bold, dramatic transformations, giving them a virtual preview before committing to an actual change. The app provides an easy and fun way for users to explore different hairstyles and find the perfect one for them.',
  ChangeHairstyle_content_2: 'Choose your favorite hairstyle below and add your own photo. You will get a beautiful and clear image.',
  Result: 'Result',
  Original: 'Original',
  unsub_tip: 'To unsubscribe, send OFF to 548',
  sub_tip: 'For subscription,send "ON1" or "ON7" to 548',
  longHairEffects: 'Long Hair Effect',
  longHairEffects_tip: 'Try the Long Hair Effect it gives you a natural and attractive hairstyle. This effect creates the look of longer hair for you.\n' +
    'Smooth & shiny\n' +
    'Natural-looking length\n' +
    'Perfect for any outfit, Look your best every day with the Long Hair Effect!',
  VIDEO: 'VIDEO',
  Yes: 'Yes',
  Monthly: 'Monthly',
  select_package: 'Please select package',
  all_package: 'All Package',
  daily_package: 'Daily Package',
  weekly_package: 'Weekly Package',
  monthly_package: 'Monthly Package',
  best_choice: 'Recommended',
  chances_2_day: '2 chances for using eMoneySnapAI / day',
  chances_14_day: '14 chances for using eMoneySnapAI / 7days',
  chances_60_day: '60 chances for using eMoneySnapAI / 30days',
  subscribeNow: 'Subscribe',
  free_first_sub: 'Free for first registration',
  home: 'Home',
  UNSUBSCRIBE: 'UNSUBSCRIBE',
  LOGOUT: 'LOGOUT',
  buy_tip1: '0.1 USD / Get 2 Chances for using eMoneySnapAI',
  buy_tip2: '0.2 USD / Get 5 chances for using eMoneySnapAI',
  buy_tip3: '0.35 USD / Get 10 chances for using eMoneySnapAI',
  style: 'style',
  smart_cutout: "Smart Cutout",
  smart_cutout_tip: "Remove the background from your photo",
  smart_cutout_desc: "Background Remove feature allows users to effortlessly remove or replace the background of any image with AI-powered precision. Whether you're creating professional product photos, fun social media posts, or artistic edits, this tool ensures a clean, seamless cutout with just one tap.",
  Choose_background: "Choose background",
  Choose_size: "Choose size",
  redirect_tip: 'You will be redirected to the browser.',
  copy_project_url: 'Copy the link and open it in your browser to upload the image',
  CopySucceeded: 'Copy Succeeded',
  payment_failed_retry: 'Payment failed, please try again',
  resub_tip: 'Your account has been unsubscribed; you may choose to continue logging in or resubscribe before the validity period expires.',

}



// WEBPACK FOOTER //
// ./src/assets/i18n/en.js